import { RevealTitle, FadeIn } from "./Reveal";

const AMBIENT = [
  "babamız geldi 🖤", "ÖDCFC sonsuza dek", "kızların hepsi burada", "36 ekibi iş başında",
  "Cellat ailesi her yerde", "baba bugün yayın var mı", "seninle gurur duyuyoruz",
  "Kars'ın gururu", "aile burada 🐍", "canlı yayını kaçırmayın", "en sadık kitle biziz",
];

export const Family = ({ texts }) => (
  <section data-testid="family-section" className="relative z-10 py-32 md:py-48 px-6 md:px-12 lg:px-24 bg-[#0D0D0D] overflow-hidden">
    <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
      {AMBIENT.map((msg, i) => (
        <span
          key={i}
          className="absolute text-[#EDEDEA] whitespace-nowrap text-sm md:text-base"
          style={{
            top: `${(i * 37 + 8) % 92}%`,
            left: `${(i * 53 + 5) % 80}%`,
            opacity: 0.05,
            filter: "blur(1.5px)",
            transform: `rotate(${(i % 3 - 1) * 4}deg)`,
          }}
        >
          {msg}
        </span>
      ))}
    </div>
    <div className="relative max-w-4xl">
      <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-3">— Topluluk</p>
      <RevealTitle testId="family-title" className="font-blackletter text-4xl sm:text-5xl lg:text-6xl text-[#EDEDEA]">
        {texts.family_title || "Cellat Ailesi"}
      </RevealTitle>
      <FadeIn delay={0.15}>
        <p className="mt-8 text-base md:text-lg text-[#A3A3A3] leading-relaxed max-w-2xl">{texts.family_body}</p>
      </FadeIn>
      <FadeIn delay={0.3}>
        <blockquote data-testid="family-quote" className="mt-14 border-l-2 border-[#8B0000] pl-6 md:pl-10">
          <p className="font-blackletter text-2xl sm:text-4xl lg:text-5xl text-[#EDEDEA] leading-tight">
            “{texts.family_quote}”
          </p>
          <cite className="block mt-4 text-xs tracking-[0.3em] text-[#8B0000] uppercase not-italic">— Viral olan slogan, ÖDCFC</cite>
        </blockquote>
      </FadeIn>
      <FadeIn delay={0.4}>
        <p className="mt-14 text-lg md:text-xl text-[#EDEDEA] font-semibold">{texts.family_message}</p>
      </FadeIn>
    </div>
  </section>
);
